import { useState } from "react";
import { themeTabs } from "@/mocks/site";

export default function Themes() {
  const [active, setActive] = useState(themeTabs[0].id);
  const current = themeTabs.find((tab) => tab.id === active) ?? themeTabs[0];

  return (
    <section id="themes" className="w-full bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-8 max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <span className="text-sm font-medium text-primary-600 tracking-widest uppercase">
            Angles
          </span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            四个方向，看懂这一类型的看点
          </h2>
          <p className="mt-4 text-foreground-700 text-sm md:text-base leading-relaxed">
            同样是讲述情感与欲望，不同作品切入的角度差别很大。下面把它们大致归为四个方向，
            方便你按兴趣对号入座。
          </p>
        </div>

        <div className="mt-8 inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-200/70">
          {themeTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActive(tab.id)}
              aria-pressed={active === tab.id}
              className={`px-4 py-2 rounded-full text-sm cursor-pointer transition-colors whitespace-nowrap ${
                active === tab.id
                  ? "bg-primary-500 text-background-50"
                  : "text-foreground-700 hover:text-primary-600"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-8 rounded-lg bg-background-50 border border-background-200 p-6 md:p-10 grid grid-cols-1 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-3">
            <h3 className="font-heading text-xl md:text-3xl font-bold text-foreground-950">
              {current.title}
            </h3>
            <p className="mt-4 text-sm md:text-base text-foreground-700 leading-relaxed">
              {current.text}
            </p>
            <ul className="mt-6 flex flex-col gap-3">
              {current.points.map((point) => (
                <li key={point} className="flex items-start gap-3 text-sm md:text-base text-foreground-700">
                  <span className="mt-0.5 w-5 h-5 shrink-0 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className="ri-check-line text-xs"></i>
                  </span>
                  {point}
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2 flex items-center">
            <div className="w-full rounded-lg bg-primary-100/70 border border-primary-200 p-6">
              <span className="w-11 h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <p className="mt-4 text-sm font-medium text-primary-900">{current.examples}</p>
              <p className="mt-3 text-xs md:text-sm text-primary-800 leading-relaxed">
                建议先看一部代表作建立整体印象，再横向对比同方向的其他影片，感受不同导演的处理方式。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}